import React from 'react';
import { X, Save } from 'lucide-react';

const inputCls = 'w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded text-sm text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-primary/20 focus:border-primary focus:bg-white outline-none transition-all';
const labelCls = 'block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5';

const TabModal = ({ show, editingTab, tabForm, onClose, onSave, onTabFormChange }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded shadow-xl max-w-md w-full overflow-hidden flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
                    <h3 className="text-base font-semibold text-gray-800">
                        {editingTab ? 'Edit Tab' : 'New Tab'}
                    </h3>
                    <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded transition-colors">
                        <X className="w-4 h-4 text-gray-500" />
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-5 space-y-4">
                    <div>
                        <label className={labelCls}>Tab Name</label>
                        <input
                            value={tabForm.name}
                            onChange={(e) => onTabFormChange('name', e.target.value)}
                            className={inputCls}
                            placeholder="Enter tab name..."
                        />
                    </div>
                    <div>
                        <label className={labelCls}>Description</label>
                        <textarea
                            rows={3}
                            value={tabForm.description}
                            onChange={(e) => onTabFormChange('description', e.target.value)}
                            className={`${inputCls} resize-none`}
                            placeholder="Enter tab description..."
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100 bg-gray-50/50">
                    <button
                        onClick={onSave}
                        disabled={!tabForm.name}
                        className="px-5 py-2 bg-primary hover:bg-primaryDark disabled:bg-gray-200 disabled:cursor-not-allowed text-white text-sm rounded transition-colors flex items-center gap-1.5 font-medium"
                    >
                        <Save className="w-3.5 h-3.5" /> Save Tab
                    </button>
                    <button
                        onClick={onClose}
                        className="px-5 py-2 bg-white hover:bg-gray-100 border border-gray-200 text-gray-600 text-sm rounded transition-colors font-medium"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TabModal;
